// 公共 http 请求
import axios from 'axios'
// import router from '@/router'
const qs = require('qs')
const service = axios.create({
  baseURL: '/api', // api的base_url
  timeout: 0, // 请求超时时间
  withCredentials: true,
})

// 添加一个请求拦截器
service.interceptors.request.use(config => {
  // 添加参数是表单类型的格式
  config.headers['X-HB-Client-Type'] = 'kdk-pc'
  if (config.contentType === 'form') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    config.data = qs.stringify(config.data)
  }
  return config
}, error => {
  if (axios.isCancel(error)) {
    console.log('Request canceled', error.message)
  }
  console.log(error) // for debug
  Promise.reject(error)
})

// 添加一个响应拦截器
service.interceptors.response.use(
  response => {
    if (response.status !== 200) {
      // 406 登陆失败  401要重新登陆
      if (response.status === 401) {

      } else {

      }
    } else {
      return response
    }
  },
  error => {
    return Promise.reject(error.response && error.response.data)
  }
)

export default service
